// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"43425b81","583":"3d8236ea"}[chunkId] + ".chunk.js";
};